module.exports = __webpack_public_path__ + "hooper-logo.png?53bffd799b21e7510562ce63c5d2868b";